angular.module("coursemap").component("studentDashButtonScriptPreview", {
  templateUrl: "templates/dash/student_dash_button_script_preview.html",
  bindings: {
    theme: "<"
  }
})
